import * as types from '../constants/actionTypes'
import { sendSms } from '../utils/sms-webapi'

export function onSMSRequestResponse(response) {
    return { type: types.SMS_REQUEST_RESPONSE, response }
}

export function onSMSRequestError(error) {
    return { type: types.SMS_REQUEST_ERROR, error }
}

export function requestSent() {
    return { type: types.SMS_REQUEST_SENT }
}

export function sendSMS(from, to, msg) {
    return function(dispatch) {
        dispatch(requestSent())
        sendSms(from, to, msg)
            .then((res) => dispatch(onSMSRequestResponse(res)))
            .catch((error) => dispatch(onSMSRequestError(error)))
    }
}
